<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
     <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <div v-if="loading">Loading...</div>
        <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Catégorie <span class="text-danger">*</span>
                      </label>
                      <Field name="categorie" v-model="categorieSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="categorieOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="categorie" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Groupe de Taxe <span class="text-danger">*</span>
                      </label>
                      <Field name="groupeTaxe" v-model="groupeTaxeSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="groupeTaxeOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="groupeTaxe" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Mode de prix <span class="text-danger">*</span>
                      </label>
                      <Field name="modeDePrix" v-model="modePrixSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="modePrixOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="modeDePrix" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Nom du produit <span class="text-danger">*</span>
                      </label>
                      <Field name="libelle" type="text"
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom du produit"/>
                      <ErrorMessage name="libelle" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Description
                      </label>
                      <Field name="description" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la description"/>
                      <ErrorMessage name="description" class="text-danger"/>
                  </div>
                  </div>

                </div>


                <!--<div class="accordion" id="basicAccordion">
    
                    <div class="accordion-item mb-0">    
                        <button class="accordion-button shadow-none fw-medium" type="button" data-bs-toggle="collapse" data-bs-target="#basicCollapseOne" aria-expanded="true" aria-controls="basicCollapseOne">
                                
                        Conditionnements
                        </button>    
                        <div id="basicCollapseOne" class="accordion-collapse collapse show" data-bs-parent="#basicAccordion">        
                            <div class="accordion-body">
                              <div v-for="(conditionnement, index) in conditionnements" :key="index">
                                  <MyConditionnement 
                                    :options="conditionnementOptions" 
                                    :index="index" 
                                    :conditionnementData="conditionnement"
                                    @update-conditionnement="updateConditionnement"
                                  />
                              </div>
                            </div>   
                        </div>
                    </div>

                </div>-->

                <div class="col-md-12">
                    <div class="card" style="padding:0px !important;">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="card-title mb-0">Conditionnement</h5>
                            <button 
                                type="button"
                                class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                @click="addConditionnement"
                            >
                                + conditionnement
                            </button>
                        </div>
                        <div class="card-body">
                            <div class="table" style="width: 100% !important;">
                                <thead 
                                v-show="showThead" 
                                style="width: 100% !important;">
                                    <th style="min-width: 300px !important;">Conditionnement</th>
                                    <th>Qté</th>
                                    <th>Prix de vente</th>
                                    <th>Prix Min</th>
                                    <th>Prix Max</th>
                                    <th>Coéfficié?</th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    <tr v-for="(conditionnement, index) in conditionnements" :key="index">
                                        
                                        
                                        <td style="margin-bottom: 5px !important;">
                                            <Field :name="'conditionnement'+index" v-model="conditionnement.conditionnement"  v-slot="{ field }" style="min-width: 50px !important;">
                                              <Multiselect
                                                  v-model = "field.value"
                                                  v-bind = "field"
                                                  :options="getFilteredOptions(index)"
                                                  :searchable="true"
                                                  placeholder="Rechercher"
                                                  noResultText= "Aucun enregistrement trouvé"
                                                  noOptionsText="Tapez au moins deux caractères" />
                                            </Field>
                                            <ErrorMessage :name="'conditionnement'+index" class="text-danger"/>
                                        </td>


                                        <td>
                                            <Field :name="'qteCond'+index" type="text" v-model="conditionnement.qteCond"
                                            class="form-control shadow-none fs-md-15 text-black" placeholder="Quantité"/>
                                            <ErrorMessage :name="'qteCond'+index" class="text-danger"/>
                                        </td>


                                        <td>
                                          <Field :name="'prix'+index" type="text" v-model="conditionnement.prix"
                                          class="form-control shadow-none fs-md-15 text-black" placeholder="Prix"/>
                                          <ErrorMessage :name="'prix'+index" class="text-danger"/>
                                        </td>


                                        <td>
                                          <Field :name="'prixMin'+index" type="text" v-model="conditionnement.prixMin" 
                                          class="form-control shadow-none fs-md-15 text-black" placeholder="Minumum"/>
                                          <ErrorMessage :name="'prixMin'+index" class="text-danger"/>
                                        </td>

                                        <td>
                                          <Field :name="'prixMax'+index" type="text" v-model="conditionnement.prixMax" 
                                          class="form-control shadow-none fs-md-15 text-black" placeholder="Maximum"/>
                                          <ErrorMessage :name="'prixMax'+index" class="text-danger"/>
                                        </td>

                                        <div>
                                          <Field 
                                            :name="'estCoefficier'+index" 
                                            type="checkbox" 
                                            v-model="conditionnement.estCoefficier"
                                            :value="true"
                                            :unchecked-value="false"
                                            class="form-check-input shadow-none fs-md-15 text-black"
                                          />
                                          <ErrorMessage :name="'estCoefficier'+index" class="text-danger"/>
                                        </div>

                                        <div v-show="false">
                                          <Field :name="'pc_libelle'" type="text" v-model="conditionnement.nomComplet" 
                                          class="form-control shadow-none fs-md-15 text-black"/>
                                          <ErrorMessage :name="'pc_libelle'" class="text-danger"/>
                                        </div>

                                        <td>
                                            <button type="button" class="btn btn-sm btn-outline-danger" @click="removeConditionnement(index)">x</button>
                                        </td>    

                                    </tr>
                                </tbody>
                            </div>
                        </div>
                    </div>
                </div>
            
              <br>

              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
     </div>
    </div>
   
   
   </template>
   
   <script lang="ts">
  import { defineComponent, ref, watch, onMounted, reactive } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { Produit } from '../../models/Produit';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  import { useRoute } from 'vue-router';
import router from '@/router';
  
  export default defineComponent({
      name: "AddProduitModal",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    props: {
      id: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }) {

      const elementSchema = Yup.object().shape({
        // code: Yup.string().required('Le code est obligatoire'),
        categorie: Yup.number().required('La catégorie est obligatoire'),
        groupeTaxe: Yup.number().required('Le groupe de taxe est obligatoire'),
        libelle: Yup.string().required('Le libelle est obligatoire'),
        description: Yup.string().notRequired(),
        modeDePrix: Yup.string().required('Le mode de prix est obligatoire'),
      });
      
      const elementForm = ref<Produit | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const sexeSelected = ref(null);
      const categorieOptions = ref([]);
      const categorieSelected = ref(null);
      const groupeTaxeOptions = ref([]);
      const groupeTaxeSelected = ref(5);
      const modePrixSelected = ref(null);
      const conditionnementOptions = ref([]);
      const showThead = ref(true);
      const modePrixOptions = ref([
        { value: "HT", label: 'Hors Taxe (HT)' },
        { value: 'TTC', label: 'Toutes Taxes Comprises (TTC)' }
      ]);
      // const produitLibelle = ref("");
      const route = useRoute();
      const loading = ref(true);

      const conditionnements = reactive([
        { 
          conditionnement: null, 
          qteCond: 0, 
          prixRevient: 0, 
          prix: 0, 
          prixMin: 0, 
          prixMax: 0, 
          nomComplet:'',
          estCoefficier: false
        }
      ]);

      
      const isUPDATE = ref(false);
      const title = ref("Ajouter un produit");
      const btntext = ref('Modifier');


      const addConditionnement = () => {
        // showThead.value = true;
        conditionnements.push({
          conditionnement: null,
          qteCond: 0,
          prixRevient: 0,
          prix: 0,
          prixMin: 0,
          prixMax: 0,
          nomComplet:"",
          estCoefficier: false
        });

        // console.log('bonjour', conditionnements);
      };


      const removeConditionnement = (index) => {
        conditionnements.splice(index, 1);
      };

      const getFilteredOptions = (index) => {
        const selectedOptions = conditionnements.map(c => c.conditionnement);
        // console.log("selectedOption", selectedOptions);
        return conditionnementOptions.value.filter((option: any) => {
          // console.log("option", option.value);
          return !selectedOptions.includes(option.value) || option.value === conditionnements[index].conditionnement;
        });
      };
  
      watch(() => props.id, (newValue) => {
        console.log("mon item", newValue);
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier le produit";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un produit";
           btntext.value = "Ajouter";
        }
      }
  
      const produitsError = ref(false); 

      onMounted( async () => {
        await fetchCategorie();
        await fetchGroupeTaxe();
        await fetchConditionnement();
        if(route.params.id) {
          await getOne(parseInt(route.params.id as string));
        }
        groupeTaxeSelected.value = 5;
        
      });

      const fetchCategorie = async () => {
        ApiService.get("/categories?limit=-1&")
        .then(({ data }) => {
          categorieOptions.value = data.data.data.map((categorie) => {
            return { 
              value: categorie.id, 
              label: categorie.libelle 
            }
          });
          // console.log("mes categories",categorieOptions.value);
        })
        .catch(({ response }) => {
          produitsError.value = true;
        });
      };

      const fetchGroupeTaxe = async () => {
        ApiService.get("/groupeTaxes")
        .then(({ data }) => {
          groupeTaxeOptions.value = data.data.data.map((groupeTaxe) => {
            return { 
              value: groupeTaxe.id, 
              label: groupeTaxe.libelle 
            }
          });
          console.log("mes groupes de taxe",groupeTaxeOptions.value);
        })
        .catch(({ response }) => {
          produitsError.value = true;
        });
      };

      const fetchConditionnement = async () => {
        ApiService.get("/conditionnements?limit=-1&")
        .then(({ data }) => {
          conditionnementOptions.value = data.data.data.map((conditionnement) => {
            return { 
              value: conditionnement.id, 
              label: conditionnement.libelle 
            }
          });
        })
        .catch(({ response }) => {
          produitsError.value = true;
        });
      };
  
     
      const getOne = async (id: number) => {
        console.log("modification initier");
        return ApiService.get("/produit/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          console.log("mon get one",donnees);

          // ici je vide le tableau de produit conditionnement
          conditionnements.length = 0; 

          // vider le modal

          // je reccupère les conditionnements du produit selectionner
          donnees.produitConditionnements.forEach(pc => {
            conditionnements.push({
              conditionnement: pc.conditionnement.id,
              qteCond: pc.qteCond,
              prixRevient: pc.prixRevient,
              prix: pc.prix,
              prixMin: pc.prixMin,
              prixMax: pc.prixMax,
              nomComplet: pc.nomComplet,
              estCoefficier: pc.estCoefficier
            });
          });

          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
            );
            
          }
          
        //   emit('openmodal', addElementModalRef.value);
        loading.value = false;
        })
        .catch(({ response }) => {
          error(response.data.message);
          loading.value = false;
        });
      }
  
      const addElement = async (values: any, elementForm) => {
         
        // Supprimer dynamiquement tous les champs liés aux conditionnements
        Object.keys(values).forEach(key => {
          if (key.startsWith('conditionnement') || 
              key.startsWith('prix') || 
              key.startsWith('prixMax') || 
              key.startsWith('prixMin') || 
              key.startsWith('qteCond')) {
            delete values[key];
          }
        });
        // ajout de mes collection dans les valeurs retounées
        values.conditionnements = conditionnements.map(condi => ({
          conditionnement: condi.conditionnement,
          qteCond: condi.qteCond,
          prix: condi.prix,
          prixMin: condi.prixMin,
          prixMax: condi.prixMax,
          estCoefficier: condi.estCoefficier
        }));

        console.log("mes valeurs", values);
        
        values = values as Produit;
        
          ApiService.put("/produit/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                // emit('close');
                router.push({ name: 'ListeProduits' });
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
      };
     
  
      // onMounted(() => {
        
      // });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        loading,
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        produitsError,
        sexeSelected,
        conditionnements,
        addConditionnement,
        categorieOptions,
        categorieSelected,
        groupeTaxeOptions,
        groupeTaxeSelected,
        modePrixSelected,
        conditionnementOptions,
        getFilteredOptions,
        modePrixOptions,
        showThead,
        // updateFields,
        removeConditionnement,
      };
    },
  });
  </script>
   
   <style scoped>
     table tbody td {
       padding-left: 0px !important;
     }
     .table > :not(caption) > * > * {
        padding-left: 0px !important;
     }
   </style>
   
   